module.exports = __webpack_public_path__ + "static/media/loading.5c9604b9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/loading.gif
// module id = 94
// module chunks = 0